module.exports = __webpack_public_path__ + "img/fi-rr-alarm-clock.28b419cf.svg";